/* assets/label-folder-loader.js
   Google-Drive browser + left-panel UI
   (полная версия, добавлены экспорт в window.filteredFolders
    и window.fetchImagesFromGoogleDrive, чтобы внешние скрипты
    могли пользоваться данными без таймаута)
*/

// ──────────────────────────────────
// Drive constants / pagination
// ──────────────────────────────────
const apiKey          = 'AIzaSyBJBZvhAc_or-GJCdEsGxzgV9lx3oSKhI0';
const rootFolderId    = '1Og8JYKHGkdUq3--JfwJeQ041k_q7MKHt';
const specificFolders = ['Dewalt', 'Makita', 'Milwaukee'];
const pageSize        = 7;

let showOnlySpecificFolders = false;
let currentPage             = 0;
let filteredFolders         = [];
window.filteredFolders      = filteredFolders;        // ← экспорт

// ──────────────────────────────────
const delay = ms => new Promise(r => setTimeout(r, ms));

// ───────────── Drive: folders ─────
async function fetchFoldersFromGoogleDrive(parentId) {
  const url = [
    'https://www.googleapis.com/drive/v3/files',
    `?q='${encodeURIComponent(parentId)}'+in+parents+and+mimeType='application/vnd.google-apps.folder'`,
    `&key=${encodeURIComponent(apiKey)}`,
    '&fields=files(id,name)'
  ].join('');
  const res  = await fetch(url);
  const json = await res.json();
  return res.ok && json.files ? json.files.map(f => ({ id: f.id, name: f.name })) : [];
}

// ───────────── Drive: images ──────
async function fetchImagesFromGoogleDrive(parentId) {
  const url = [
    'https://www.googleapis.com/drive/v3/files',
    `?q='${encodeURIComponent(parentId)}'+in+parents`,
    `&key=${encodeURIComponent(apiKey)}`,
    '&fields=files(id,name,mimeType)'
  ].join('');
  const res  = await fetch(url);
  const json = await res.json();
  if (!res.ok || !json.files) return [];
  return json.files.map(f => ({
    id:       f.id,
    name:     f.name,
    fullUrl:  `https://drive.google.com/uc?export=download&id=${f.id}`,
    thumbUrl: f.mimeType === 'image/svg+xml'
      ? `https://drive.google.com/uc?export=download&id=${f.id}`
      : `https://drive.google.com/thumbnail?id=${f.id}&sz=w300`
  }));
}
window.fetchImagesFromGoogleDrive = fetchImagesFromGoogleDrive;   // ← экспорт

// ───────── gallery bridge ─────────
function displayImages(images) {
  if (!Array.isArray(images) || !images.length) return;

  const first = images.find(img => img && (img.fullUrl || img.thumbUrl));
  const href = first && (first.fullUrl || first.thumbUrl);

  if (href && typeof window.setLabelImage === 'function') {
    window.setLabelImage(href);
  }

  window.dispatchEvent(new CustomEvent('label:folder-images-loaded', {
    detail: { images }
  }));
}

// ───────── monitor typing ─────────
const monitorTextPhrase = 'Please, stand by...';
let monitorTextToken = 0, isTyping = false;

async function typeMonitorText() {
  if (isTyping) return;
  isTyping = true;
  const token = ++monitorTextToken;
  const tspan = document.querySelector('.monitor-st0 tspan');
  if (!tspan) { isTyping = false; return; }
  tspan.textContent = '';
  for (const ch of monitorTextPhrase) {
    if (token !== monitorTextToken) { isTyping = false; return; }
    tspan.textContent += ch;
    await delay(100);
  }
  isTyping = false;
}
function hideMonitorText() {
  monitorTextToken++; isTyping = false;
  const tspan = document.querySelector('.monitor-st0 tspan');
  if (tspan) tspan.textContent = '';
}

// ───────── hover slide ───────────
let hoverToken = 0, hoverAnim = null;
function stopMonitorSlide() {
  hoverToken++;
  if (hoverAnim) { hoverAnim.cancel(); hoverAnim = null; }
  const row = document.querySelector('#hover-fo .hover-row');
  if (row) { row.style.visibility = 'hidden'; row.innerHTML = ''; }
  typeMonitorText();
}
async function startMonitorSlide(folderId, token) {
  if (token !== hoverToken) return;
  hideMonitorText();
  const fo  = document.getElementById('hover-fo');
  const row = fo.querySelector('.hover-row');
  row.innerHTML = ''; row.style.visibility = 'hidden';

  const images = await fetchImagesFromGoogleDrive(folderId);
  if (token !== hoverToken) return;
  if (!images.length) { typeMonitorText(); return; }

  await Promise.all(images.map(d => new Promise(res => {
    const img = document.createElement('img');
    img.src = d.thumbUrl;
    img.onload = () => { row.appendChild(img); res(); };
    img.onerror = res;
  })));
  if (token !== hoverToken) return;

  row.style.visibility = '';
  const totalW = row.scrollWidth, viewW = fo.clientWidth;
  const speed = 100, duration = ((viewW + totalW) / speed) * 1000;

  hoverAnim = row.animate(
    [{ transform:`translateX(${viewW}px)` }, { transform:`translateX(${-totalW}px)` }],
    { duration, iterations: Infinity, easing: 'linear', fill: 'forwards' }
  );
}

// ───────── page render ───────────
function renderPage() {
  stopMonitorSlide(); hideMonitorText();

  const start = currentPage * pageSize;
  const pageFolders = filteredFolders.slice(start, start + pageSize);
  const items = [...document.querySelectorAll('#folder-buttons-row .label-horizontal-section__button-row-item')];

  items.forEach((item, idx) => {
    const btn = item.querySelector('svg.choosebutton');
    if (idx < pageFolders.length) {
      const { id, name } = pageFolders[idx];
      item.style.display = ''; btn.dataset.folderId = id;
      const t = btn.querySelector('text'); if (t) t.textContent = name;
    } else {
      item.style.display = 'none'; delete btn.dataset.folderId;
    }
    item.style.transform = '';
  });

  document.getElementById('prev-folder-button').disabled = currentPage === 0;
  document.getElementById('next-folder-button').disabled =
    currentPage >= Math.ceil(filteredFolders.length / pageSize) - 1;
}

// ───────── init / events ─────────
document.addEventListener('DOMContentLoaded', async () => {
  const allFolders = await fetchFoldersFromGoogleDrive(rootFolderId);
  filteredFolders  = allFolders.filter(f =>
    showOnlySpecificFolders ? specificFolders.includes(f.name)
                            : !specificFolders.includes(f.name)
  );
  window.filteredFolders = filteredFolders;          // keep export fresh
  renderPage(); await typeMonitorText();

  const prevBtn = document.getElementById('prev-folder-button');
  const nextBtn = document.getElementById('next-folder-button');
  const items   = [...document.querySelectorAll('#folder-buttons-row .label-horizontal-section__button-row-item')];

  async function pageTransition(dir) {
    prevBtn.disabled = nextBtn.disabled = true;

    const outKF = dir==='next'
      ? [{transform:'translateY(0) rotate(0deg)'},{transform:'translateY(-10px) rotate(-10deg)'},{transform:'translateX(-100vw) rotate(-10deg)'}]
      : [{transform:'translateY(0) rotate(0deg)'},{transform:'translateY(-10px) rotate(10deg)'},{transform:'translateX(100vw) rotate(10deg)'}];

    await Promise.all(items.map((el,i)=>el.animate(outKF,{duration:1000,easing:'ease-in',fill:'forwards',delay:i*100}).finished));

    currentPage += dir==='next'?1:-1;
    renderPage();

    const inKF = dir==='next'
      ? [{transform:'translateX(100vw) rotate(10deg)'},{transform:'translateY(-10px) rotate(10deg)'},{transform:'translateY(0) rotate(0deg)'}]
      : [{transform:'translateX(-100vw) rotate(-10deg)'},{transform:'translateY(-10px) rotate(-10deg)'},{transform:'translateY(0) rotate(0deg)'}];

    items.forEach(el=>{ el.style.transform = dir==='next' ? 'translateX(100vw) rotate(10deg)' : 'translateX(-100vw) rotate(-10deg)'; });
    await Promise.all(items.map((el,i)=>el.animate(inKF,{duration:600,easing:'ease-out',fill:'forwards',delay:i*100}).finished));

    prevBtn.disabled = currentPage === 0;
    nextBtn.disabled = currentPage >= Math.ceil(filteredFolders.length / pageSize) - 1;
  }

  prevBtn.addEventListener('click', () => { if (currentPage>0) pageTransition('prev'); });
  nextBtn.addEventListener('click', () => {
    const max = Math.ceil(filteredFolders.length / pageSize) - 1;
    if (currentPage < max) pageTransition('next');
  });

  items.forEach(item => {
    const btn = item.querySelector('svg.choosebutton');
    btn.addEventListener('click', async () => {
      const id = btn.dataset.folderId;
      if (id) displayImages(await fetchImagesFromGoogleDrive(id));
    }, { passive: true });
    btn.onmouseenter = () => { hoverToken++; const tok=hoverToken;
      const id=btn.dataset.folderId; if(id) startMonitorSlide(id,tok); };
    btn.onmouseleave = stopMonitorSlide;
  });
});
